import type { ActionTree } from "vuex";
import {
  LOAD_ALERT_EVENT,
  LOAD_ALERT_EVENT_SUCCESS,
  LOAD_ALERT_EVENT_FAILURE,
} from "./mutations";
import { httpClient, type AxiosResponse } from "@/services/httpClient";
import type { RootState, StatState, AlertEventStat } from "@/types";
import { HOSTS, ENDPOINTS } from "@/constants";

export const actions: ActionTree<StatState, RootState> = {
  // Stat alert event
  fetchAlertEventStat({ commit }, params?: any) {
    commit(LOAD_ALERT_EVENT);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.STATS_ALERT_EVENT}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<AlertEventStat[]>) => {
          commit(LOAD_ALERT_EVENT_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_ALERT_EVENT_FAILURE, error.message);
        },
      );
  },
};
